import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width={456} height={617} fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#prefix__clip0)">
      <path
        d="M346.602 235.303c60.024 0 108.683-48.616 108.683-108.588 0-59.972-48.659-108.589-108.683-108.589-60.024 0-108.683 48.617-108.683 108.589s48.659 108.588 108.683 108.588z"
        fill="url(#prefix__paint0_radial)"
      />
      <path
        d="M358.334 194.255c.503 5.146-2.984 9.294-12.448 9.294-.237 0-.47-.009-.701-.025-9.562-.688-10.796-14.376-1.627-17.172l1.671-.51c5.549-1.691 11.385 1.599 12.803 7.219l.302 1.194z"
        fill="url(#prefix__paint1_linear)"
      />
      <path
        d="M88.11 526.201c-1.923-8.742-30.943-31.571-39.416-30.34-8.473 1.23 8.451 28.325 17.106 32.552 8.655 4.227 22.31-2.212 22.31-2.212zM288.995 196.815c5.017-3.081 15.201-18.398 20.209-34.909 5.008-16.51 3.312-34.447-3.602-29.857-6.914 4.591-20.685 23.103-24.191 34.486-3.505 11.381-8.118 38.172 7.584 30.28z"
        fill="#172845"
      />
      <path
        d="M264.556 186.943c20.824-11.138 41.164-28.353 42.763-29.418 1.599-1.065 26.384-2.135 31.181-3.065 4.797-.93 18.122-34.529 0-32.374-18.122 2.155-35.043 10.742-56.274 20.984-21.232 10.243-45.718 58.874-17.67 43.873z"
        fill="#172845"
      />
      <path
        d="M338.5 122.086c-10.135 1.206-19.895 4.425-30.243 8.818-1.713 2.348-3.071 4.96-4.179 7.639-2.82 6.82-4.239 14.138-5.467 21.384a78.579 78.579 0 00-.651 4.908c5.248-4.014 8.734-6.895 9.359-7.31 1.599-1.065 26.383-2.135 31.18-3.065 4.797-.93 18.123-34.528.001-32.374z"
        fill="url(#prefix__paint2_linear)"
      />
      <path
        d="M353.664 55.095c-12.297-2.14-22.964.796-23.676 5.922-.06.433-.02.868.035 1.315 3.38 27.758 8.601 81.53-17.888 128.442 9.969 2.349 44.227 8.266 44.227 8.266s-2.328-33.3 3.347-76.599c4.052-30.923 9.871-45.054 12.867-50.606 1.098-.868 1.783-1.898 1.946-3.072.712-5.126-8.56-11.529-20.858-13.668z"
        fill="url(#prefix__paint3_linear)"
      />
      <path
        d="M314.764 191.36c12.287 2.618 41.597 7.681 41.597 7.681s-.603-8.634-.447-22.82c-5.404-.489-10.836-.687-16.268-.748-6.279-.071-13.125.057-19.066 2.435-2.158 4.386-4.024 8.905-5.816 13.452z"
        fill="url(#prefix__paint4_linear)"
      />
      <path
        d="M356.326 199.652c-.712 5.125-11.259 7.546-23.557 5.408-12.298-2.14-21.69-8.028-20.977-13.154.713-5.125 11.26-7.547 23.558-5.408 12.297 2.138 21.689 8.028 20.976 13.154z"
        fill="url(#prefix__paint5_linear)"
      />
      <path
        d="M356.326 199.652c.539-3.873-4.692-8.18-12.583-10.977a114.898 114.898 0 00-.059 9.461c-.004-.013-.01-.025-.015-.037-3.36 3.165-8.391 1.373-13.256-.007l1.453-6.579c-4.542-.7-8.907-.276-10.087 1.509l-.205.405c-.512.951 4.443 14.297 30.957 10.428 2.182-1.043 3.554-2.467 3.795-4.203z"
        fill="url(#prefix__paint6_linear)"
      />
      <path
        d="M331.865 191.513l-1.453 6.579c4.865 1.38 9.896 3.172 13.256.006-1.074-3.465-6.554-5.776-11.803-6.585z"
        fill="url(#prefix__paint7_linear)"
      />
      <path d="M321.78 193.022z" fill="url(#prefix__paint8_linear)" />
      <path d="M343.676 198.093l-.008.007.015.037c-.133-3.73-.056-7.027.059-9.461l-.005-.002c-.117 2.422-.193 5.7-.061 9.419z" fill="#F0E6DA" />
      <path
        d="M343.676 198.093l-.008.007.015.037c-.133-3.73-.056-7.027.059-9.461l-.005-.002c-.117 2.422-.193 5.7-.061 9.419z"
        fill="url(#prefix__paint9_linear)"
      />
      <path
        d="M343.676 198.093l-.008.007.015.037c-.133-3.73-.056-7.027.059-9.461l-.005-.002c-.117 2.422-.193 5.7-.061 9.419z"
        fill="url(#prefix__paint10_linear)"
      />
      <path d="M321.78 193.022c1.179-1.784 5.544-2.208 10.086-1.508l.004-.019c-4.543-.692-8.91-.259-10.09 1.527z" fill="#F0E6DA" />
      <path
        d="M321.78 193.022c1.179-1.784 5.544-2.208 10.086-1.508l.004-.019c-4.543-.692-8.91-.259-10.09 1.527z"
        fill="url(#prefix__paint11_linear)"
      />
      <path
        d="M321.78 193.022c1.179-1.784 5.544-2.208 10.086-1.508l.004-.019c-4.543-.692-8.91-.259-10.09 1.527z"
        fill="url(#prefix__paint12_linear)"
      />
      <path d="M331.871 191.494l-.005.02c5.248.808 10.729 3.12 11.803 6.585l.007-.006c-1.045-3.486-6.542-5.797-11.805-6.599z" fill="#F0E6DA" />
      <path
        d="M331.871 191.494l-.005.02c5.248.808 10.729 3.12 11.803 6.585l.007-.006c-1.045-3.486-6.542-5.797-11.805-6.599z"
        fill="url(#prefix__paint13_linear)"
      />
      <path
        d="M331.871 191.494l-.005.02c5.248.808 10.729 3.12 11.803 6.585l.007-.006c-1.045-3.486-6.542-5.797-11.805-6.599z"
        fill="url(#prefix__paint14_linear)"
      />
      <path
        d="M331.871 191.494c5.263.802 10.76 3.114 11.805 6.599-.132-3.719-.055-6.997.062-9.42a51.947 51.947 0 00-8.388-2.175c-4.061-.706-7.926-.913-11.314-.691l-2.461 7.62c.051-.142.12-.277.205-.406 1.18-1.786 5.547-2.219 10.091-1.527z"
        fill="url(#prefix__paint15_linear)"
      />
      <path
        d="M338.549 126.226c-3.874 22.924-13.512 47.692-18.096 56.593 11.956-3.6 32.924 1.361 37.881 11.436-3.808-42.614 3.754-95.501 17.594-126.735-3.779-13.875-25.675-17.696-37.393-15.278 1.889 11.308 4.884 45.156.014 73.984z"
        fill="url(#prefix__paint16_linear)"
      />
      <path
        d="M362.602 113.669c8.994 5.142 6.54 13.073-3.692 15.964-6.221 1.758-8.128 1.239-7.99-1.239.138-2.477 2.893-4.555 5.648-6.407 2.756-1.852 3.968-2.4 3.968-2.4l2.066-5.918z"
        fill="url(#prefix__paint17_linear)"
      />
      <path
        d="M359.726 135.297c1.451 1.878 4.201 6.789 1.252 11.254-2.951 4.467-7.42 7.414-9.834 5.895-2.414-1.518 1.966-7.502 3.844-9.646 1.878-2.144 2.821-5.538 2.821-5.538l1.917-1.965z"
        fill="url(#prefix__paint18_linear)"
      />
      <path
        d="M362.863 128.591c7.143 7.501 3.462 12.76-7.329 14.982-6.332 1.304-8.221-.082-7.687-2.505.534-2.423 3.645-3.454 6.662-4.84 3.017-1.385 4.677-2.558 4.677-2.558l3.677-5.079z"
        fill="url(#prefix__paint19_linear)"
      />
      <path
        d="M361.731 122.169c7.738 6.887 4.504 12.431-6.066 15.536-6.203 1.821-8.201.596-7.869-1.863.333-2.46 3.348-3.743 6.241-5.373 2.892-1.63 4.449-2.935 4.449-2.935l3.245-5.365z"
        fill="url(#prefix__paint20_linear)"
      />
      <path
        d="M196.595 80.94c9.132-.548 16.79 9.18 28.019 27.557 10.384 16.992 24.722 33.463 30.056 36.747 5.234 3.224 50.932-13.195 50.932-13.195-13.648 7.664-33.101 73.575-15.884 64.359-17.17 9.672-21.881 12.764-33.388 9.662-11.507-3.102-36.721-29.502-48.046-55.417-11.324-25.915-29.773-68.984-11.689-69.713z"
        fill="url(#prefix__paint21_linear)"
      />
      <path
        d="M220.238 101.516c-8.953-13.837-15.747-21.05-23.643-20.577-18.083.73.365 43.8 11.69 69.714 3.564 8.155 10.719 20.451 17.744 28.869 2.371-5.605 12.891-34.277-5.791-78.006z"
        fill="url(#prefix__paint22_linear)"
      />
      <path
        d="M182.09 75.431c5.407-1.93 16.071-3.025 25.159 3.387 16.377 11.554 14.003 32.185 11.868 55.663-2.136 23.477-37.027-59.05-37.027-59.05z"
        fill="url(#prefix__paint23_linear)"
      />
      <path
        d="M305.602 132.049c12.142-6.952 27.915-14.764 32.477-15.3 4.562-.536 12.244 3.701 14.502 6.746 1.21 1.633.812 6.298.486 8.9-.629 5.022-5.337 5.619-7.225-.618-1.36-4.495-6.113-3.189-8.822 1.821-2.146 3.971-4.594 7.955-12.333 10.533"
        fill="url(#prefix__paint24_linear)"
      />
      <path
        d="M333.555 179.651c-1.953 11.946-1.298 30.162-1.298 30.162s-3.685-3.134-6.233-6.33c-3.792 3.022-5.93 5.202-5.93 5.202s.058-18.392 3.61-31.688l9.851 2.654z"
        fill="url(#prefix__paint25_linear)"
      />
      <path
        d="M336.774 166.534l1.355 3.378 2.968 2.11-.688 3.572 1.355 3.378-2.512 2.635-.688 3.572-3.538.86-2.513 2.634-3.441-1.188-3.539.86-2.252-2.86-3.443-1.188-.347-3.623-2.253-2.858 1.668-3.236-.348-3.621 3.152-1.821 1.668-3.235 3.638.171 3.153-1.821 2.967 2.11 3.638.171z"
        fill="url(#prefix__paint26_linear)"
      />
      <path
        d="M329.44 182.249a5.49 5.49 0 005.492-5.487 5.49 5.49 0 00-5.492-5.487 5.49 5.49 0 00-5.492 5.487 5.49 5.49 0 005.492 5.487z"
        fill="url(#prefix__paint27_linear)"
      />
      <path
        d="M158.18 221.602c-22.752 2.498-57.757 7.911-63.174-12.075-5.418-19.986-3.75-84.796-2.084-108.601 1.667-23.805 25.401-34.631 54.998-34.631 29.598 0 32.516 1.765 32.932 14.623.417 12.857 12.999 136.104-22.672 140.684z"
        fill="url(#prefix__paint28_linear)"
      />
      <path
        d="M91.984 119.275c.664-14.066 5.254-26.092 14.927-29.716 9.674-3.624 41.599-4.35 41.599-4.35l17.832-8.457s-48.063.598-61.124 4.165c-13.06 3.567-12.732 20.715-13.234 38.358z"
        fill="#172845"
      />
      <path
        d="M100.041 122.751c-14.917-.073-18.99 4.312-20.395 13.798-1.407 9.487-.352 47.834 2.461 56.943 2.813 9.109 26.022 12.159 30.242-1.838 4.22-13.998 2.697-44.51 1.876-52.969-.822-8.46-5.917-15.894-14.184-15.934z"
        fill="url(#prefix__paint29_linear)"
      />
      <path
        d="M265.831 467.7c.84 6.445-3.71 11.537-9.352 15.901-5.641 4.363-30.563 14.843-40.391 17.571-9.828 2.728-32.691 8.25-32.691.262 0-13.823 24.502-44.018 47.057-53.292 22.555-9.274 32.899 4.022 35.377 19.558z"
        fill="url(#prefix__paint30_linear)"
      />
      <path
        d="M257.919 448.449c2.059 33.544 1.765 65.213 4.234 92.709 2.469 27.495-29.636 39.128-39.162 3.172-9.526-35.955-13.407-67.681-15.524-88.126-2.117-20.445 48.982-31.708 50.452-7.755z"
        fill="#172845"
      />
      <path
        d="M257.919 448.449c2.059 33.544 1.765 65.213 4.234 92.709 2.469 27.495-29.636 39.128-39.162 3.172-9.526-35.955-13.407-67.681-15.524-88.126-2.117-20.445 48.982-31.708 50.452-7.755z"
        fill="url(#prefix__paint31_linear)"
      />
      <path
        d="M259.371 480.995c-1.359 1.951-2.45 4.11-3.437 6.252-1.246 2.706-2.259 5.494-3.331 8.269-1.447 3.746-5.008 18.333-5.918 22.326-1.845 8.098-4.307 17.207-5.439 25.428a977.336 977.336 0 00-2.822 22.5c12.026 4.668 25.353-6.528 23.729-24.612-1.654-18.41-2.071-38.7-2.782-60.163z"
        fill="url(#prefix__paint32_linear)"
      />
      <path
        d="M91.881 327.536c2.903 8.622 34.701-3.808 40.055-12.804 5.354-8.997 4.081-10.231 3.071-15.184-1.011-4.954-12.529-13.077-26.283-7.905-13.756 5.172-20.485 21.177-16.843 35.893z"
        fill="url(#prefix__paint33_linear)"
      />
      <path
        d="M138.122 143.335c.363 14.269 3.95 35.326 13.431 43.417 9.25 7.894 37.337 4.754 46.594.96 18.322-7.509 18.338-11.678 20.857-16.609 2.519-4.931 9.272-31.141 3.038-55.015-6.234-23.874-19.178-35.172-33.037-37.271-12.986-1.967-25.223-3.693-40.433.014-14.682 9.986-10.807 50.537-10.45 64.504z"
        fill="url(#prefix__paint34_linear)"
      />
      <path
        d="M164.197 163.637a74.477 74.477 0 001.533 10.809c1.427-.506 2.893-.908 4.372-1.266a90.53 90.53 0 018.179-1.572 109.536 109.536 0 0115.082-1.132c4.559-.032 9.084.299 13.625.646 3.753.286 7.531.631 11.19 1.552.022.006.044.013.067.018.241-.523.486-1.051.76-1.587 2.519-4.931 9.271-31.141 3.038-55.015-6.234-23.874-19.178-35.172-33.037-37.272-9.54-1.444 2.892 13.86-7.317 14.733-.094.965-21.762-14.68-21.869-13.715-.612 5.531-1.338 11.056-1.582 16.619-.122 2.78-.128 5.569.098 8.344.111 1.36.279 2.715.528 4.057.213 1.153.422 2.367.951 3.424 1.589 3.175 5.508 2.582 7.868 4.782 3.608 3.367-3.856 41.184-3.486 46.575z"
        fill="url(#prefix__paint35_linear)"
      />
      <path
        d="M161.758 190.823c-8.48-1.115-11.146-4.058-5.874-6.731 6.183-3.135 13.616-5.372 13.616-5.372l-7.742 12.103zM135.063 461.305c-20.807 26.405-42.123 49.846-58.595 72.01-16.472 22.164-45.408 10.764-31.343-23.673 15.697-38.434 30.646-57.686 42.685-74.353 12.039-16.668 62.111 7.161 47.253 26.016z"
        fill="#172845"
      />
      <path
        d="M135.063 461.305c-20.807 26.405-42.123 49.846-58.595 72.01-16.472 22.164-45.408 10.764-31.343-23.673 15.697-38.434 30.646-57.686 42.685-74.353 12.039-16.668 62.111 7.161 47.253 26.016z"
        fill="url(#prefix__paint36_linear)"
      />
      <path
        d="M257.14 254.236c-6.842-24.038-23.45-52.613-44.816-76.093-14.318-6.167-34.889-3.77-48.778 1.583-2.369.913-4.304 2.682-5.383 4.979-9.549 20.343-28.622 61.325-37.004 102.73-8.758 43.269-9.223 87.26-9.223 87.26s-9.387 7.37-3.637 12.208c-19.37 17.538-25.623 44.435-36.822 58.174-11.199 13.739.812 35.91 16.636 51.258 12.485 12.109 29.671 14.362 34.211 9.524 4.54-4.838 41.665-82.668 53.469-104.441 3.368-6.213 7.419-17.524 11.595-30.809l-3.99 130.825c0-4.643 28.533-26.89 57.597-36.492 10.628-3.51 23.723-5.38 24.837 2.758-6.009-32.015 4.763-166.194-8.692-213.464z"
        fill="url(#prefix__paint37_linear)"
      />
      <path
        d="M116.313 411.163l.701-1.753a74.329 74.329 0 001.555-4.421c1.134-3.543 2.115-8.123 1.913-11.606-.094-1.71-.445-3.712-1.639-5.09-1.154-1.415-3.14-1.899-4.907-1.868-1.786.013-3.382.416-4.494.732-.563.144-1.004.302-1.31.403l-.473.157c-.371.115-.695-.708-.342-.871l.474-.197c.307-.127.75-.321 1.325-.512 1.137-.405 2.769-.945 4.767-1.079a9.448 9.448 0 013.194.297c1.101.303 2.197.932 3.011 1.826.819.888 1.372 1.969 1.686 3.029.316 1.063.471 2.111.52 3.08.202 3.902-1.071 8.591-2.431 12.146a64.382 64.382 0 01-1.865 4.396 60.982 60.982 0 01-.834 1.721c-.245.32-.954-.017-.851-.39zM125.016 366.574s-3.91 2.762-6.562 4.307c-2.661 1.531-7.003 3.547-7.003 3.547-.154.065-.593-.704-.47-.81 0 0 3.91-2.761 6.562-4.306 2.661-1.532 7.003-3.548 7.003-3.548.188-.001.58.679.47.81z"
        fill="#172845"
      />
      <path
        d="M257.14 254.236c-6.842-24.038-23.449-52.613-44.815-76.093-8.547-3.681-19.321-4.309-29.572-3.081-4.305 10.144-12.828 31.008-21.615 56.995-12.522 37.034-6.961 105.878-19.954 129.42-12.994 23.543-43.555 88.032-53.07 134.858 12.484 12.11 29.671 14.362 34.211 9.524 4.32-4.604 38.145-75.3 51.581-100.896l.001-.001c5.184-8.955 10.208-24.633 13.481-34.353 10.204-30.298 16.569-57.488 20.647-74.158 5.386-22.017 12.196-30.684 16.63-36.381 4.435-5.698-4.03 13.639-4.03 13.639 16.439 68.983 2.579 140.434 13.924 193.57a125.847 125.847 0 016.437-2.337c10.627-3.51 23.722-5.38 24.836 2.758-6.009-32.015 4.763-166.194-8.692-213.464z"
        fill="url(#prefix__paint38_linear)"
      />
      <path
        d="M133.165 483.892c-.719-.038-1.731-.174-2.991-.327a58.31 58.31 0 01-10.165-2.387c-3.963-1.289-8.217-3.285-12.168-5.705a58.91 58.91 0 01-10.368-8.235 58.87 58.87 0 01-8.171-10.417c-2.394-3.964-4.361-8.228-5.624-12.198a58.193 58.193 0 01-2.32-10.172c-.148-1.302-.284-2.346-.311-3.067l-.017-.242c-.315.133-.624.278-.935.419.014.732.11 1.746.217 3.013.275 2.655.86 6.363 2.08 10.452 1.19 4.094 3.107 8.516 5.5 12.639 2.424 4.107 5.38 7.862 8.315 10.829 2.948 2.952 6.686 5.932 10.781 8.382 4.109 2.42 8.521 4.367 12.611 5.584a57.944 57.944 0 0010.446 2.15c1.299.118 2.339.226 3.074.241.023-.319.035-.638.046-.959zM260.971 513.469c-21.37 2.685-32.167 8.599-44.133 15.672a4.326 4.326 0 00-1.925 5.033l13.891 43.618 39.471-10.035-2.436-50.006c-.004-2.596-2.29-4.606-4.868-4.282z"
        fill="#172845"
      />
      <path
        d="M260.971 513.469c-21.37 2.685-32.167 8.599-44.133 15.672a4.326 4.326 0 00-1.925 5.033l13.891 43.618 39.471-10.035-2.436-50.006c-.004-2.596-2.29-4.606-4.868-4.282z"
        fill="url(#prefix__paint39_linear)"
      />
      <path
        d="M265.84 517.751c-.005-2.596-2.291-4.606-4.869-4.282-5.212.655-9.786 1.505-13.909 2.514a8.438 8.438 0 00-.377 1.859c1.639.056 13.066-1.407 14.699-1.408 1.927-.003 3.638.264 4.464 1.469l-.008-.152z"
        fill="url(#prefix__paint40_linear)"
      />
      <path
        d="M226.31 568.95c14.465-4.75 27.755-17.527 41.085-20.59 3.079-.707 6.047 1.593 6.183 4.747.429 9.965 2.335 26.038 10.623 34.318 6.396 6.391 18.196 11.262 26.229 14.038 5.045 1.743 8.415 6.503 8.415 11.836v2.378c0 .731-.593 1.322-1.324 1.322h-89.933c-2.201-9.703-6.782-23.163-1.156-30.541l-3.217-11.678c-.678-2.456.672-5.034 3.095-5.83z"
        fill="url(#prefix__paint41_linear)"
      />
      <path
        d="M226.31 568.95c14.465-4.75 27.755-17.527 41.085-20.59 3.079-.707 6.047 1.593 6.183 4.747.429 9.965 2.335 26.038 10.623 34.318 6.396 6.391 18.196 11.262 26.229 14.038 5.045 1.743 8.415 6.503 8.415 11.836v2.378c0 .731-.593 1.322-1.324 1.322h-89.933c-2.201-9.703-6.782-23.163-1.156-30.541l-3.217-11.678c-.678-2.456.672-5.034 3.095-5.83z"
        fill="url(#prefix__paint42_linear)"
      />
      <path
        d="M279.651 581.262c.701 3.988 1.74 8.006 3.959 11.443 2.65 4.106 6.858 6.78 11.375 8.465 5.128 1.914 10.602 2.441 15.92 3.591 2.09.452 4.088 1.118 6.038 1.904a12.472 12.472 0 00-6.512-5.202c-8.033-2.776-19.834-7.647-26.229-14.038-1.826-1.824-3.342-4.027-4.6-6.459.016.098.031.198.049.296z"
        fill="url(#prefix__paint43_linear)"
      />
      <path
        d="M247.755 540.158l8.745-5.468c.419-.258.374-.239.457-.296l.173-.127c.102-.077.178-.137.228-.182l-.445.087-.151.037-.057.016-.583.085c-3.218.485-6.398 1.08-9.18 1.659-5.57 1.122-12.593 2.987-18.128 4.866a152.73 152.73 0 00-6.882 2.512l-2.73 1.104c-.569.226-.915-.589-.381-.854 0 0 1.005-.483 2.697-1.237a132.445 132.445 0 016.836-2.813c5.513-2.104 12.573-4.208 18.219-5.353a121.286 121.286 0 019.321-1.538l1.795-.221 2.23-.238 2.189-.226 1.069-.11.527-.054.262-.027.131-.013.065-.007c.026-.003.048-.006.012.011-1.258.746-2.5 1.48-3.716 2.2a5528.9 5528.9 0 01-3.256 1.895l-8.968 5.097c-.568.23-.963-.448-.479-.805z"
        fill="#172845"
      />
      <path
        d="M46.347 497.131l-20.85 37.66 34.419 21.758 27.575-27.953c1.437-1.457.593-3.904-1.433-4.199-14.252-2.077-30.197-14.437-35.227-26.968-.784-1.952-3.466-2.138-4.484-.298z"
        fill="url(#prefix__paint44_linear)"
      />
      <path
        d="M29.615 528.895c16.152 20.277 25.25 13.042 39.955 18.346 2.658.959 3.523 4.288 1.658 6.41-6.532 7.433-12.155 15.177-12.484 26.956-.253 9.039 1.08 14.296 8.966 17.491 4.996 2.025 9.066 10.089 8.779 15.468L76.305 617H28.933c-13.688 0-10.915-27.95-17.488-36.023C5.04 573.108.163 567.38 0 563.53c3.08-10.431 8.333-23.523 17.563-24.508l5.89-9.711c1.354-2.234 4.533-2.461 6.162-.416z"
        fill="url(#prefix__paint45_linear)"
      />
      <path
        d="M54.91 561.821c-1.736-.913-3.84-2.316-5.324-3.716a25.697 25.697 0 01-1.775-1.842l-.65-.801c-.144-.151-.878.317-.765.513l.572.922c.381.559.937 1.329 1.652 2.147 1.419 1.643 3.567 3.355 5.45 4.351 1.88 1.004 4.5 1.83 6.657 2.089.69.086 1.32.128 1.867.149.188-.362.386-.718.584-1.073a25.216 25.216 0 01-2.21-.4c-1.992-.45-4.331-1.41-6.058-2.339zM43.876 567.556a32.79 32.79 0 002.11 1.221c1.72.919 3.996 1.818 5.848 2.282 1.852.465 4.283.745 6.233.746.795.003 1.502-.026 2.068-.059.107-.361.209-.726.325-1.079a45.607 45.607 0 01-2.31-.205c-1.861-.211-4.13-.686-5.881-1.133-1.755-.432-3.98-1.085-5.721-1.776a44.053 44.053 0 01-2.163-.922l-.855-.409c-.178-.068-.633.675-.467.794l.813.54zM58.537 577.744s-1.07.225-2.507.402c-1.435.181-3.241.289-4.653.228-1.412-.067-3.2-.336-4.613-.648-1.415-.306-2.46-.626-2.46-.626-.144-.048.03-.901.176-.903 0 0 1.067.108 2.472.196 1.406.094 3.147.143 4.507.198 1.358.067 3.097.176 4.505.21 1.408.038 2.48.027 2.48.027.155.078.233.844.093.916zM71.795 531.747l-2.125-.4c-.66-.144-1.434-.381-2.314-.615-.883-.229-1.816-.626-2.836-.976-4.034-1.54-8.606-4.519-11.642-7.449-3.056-2.91-6.223-7.351-7.929-11.315-.392-1.005-.827-1.919-1.094-2.791-.27-.87-.539-1.633-.71-2.285l-.487-2.104c-.094-.441.763-.606.897-.208l.6 2.009c.203.622.507 1.347.814 2.169.301.826.772 1.687 1.196 2.632 1.838 3.733 5.031 7.836 7.948 10.606 2.89 2.797 7.125 5.816 10.934 7.498.962.383 1.843.818 2.68 1.085.837.272 1.574.547 2.203.724l2.035.516c.404.182.27.941-.17.904zM36.006 528.759s.014-.02.447-.583l.161-.21.615.276c.035.016.248.443.803.946a4.946 4.946 0 002.585 1.235c.28.035.57.059.862.039.28-.012.615-.059.81-.131.213-.094.178-.115.19-.175.018-.077-.019-.335-.128-.618a77.908 77.908 0 01-1.452-3.907 74.923 74.923 0 01-2.306-8.683c-.564-2.742-.73-4.868-.73-4.868-.022-.295.843-.393.912-.126 0 0 .368 2.039 1.128 4.681.737 2.647 1.825 5.891 2.687 8.428l1.335 3.96c.112.4.255.881.105 1.514a1.7 1.7 0 01-.518.846 1.99 1.99 0 01-.762.404c-.486.129-.858.134-1.26.13a5.701 5.701 0 01-1.134-.139c-1.447-.335-2.506-1.141-3.108-1.828-.617-.688-.816-1.241-.838-1.271l.776.065-.452.578c-.247.17-.855-.306-.728-.563zM66.702 597.857l-1.16-.459a31.948 31.948 0 00-2.957-.904c-2.39-.611-5.44-.886-7.817-.85-2.378.015-5.42.355-7.797 1.017-1.188.326-2.21.69-2.938.967l-1.149.484c-.242.094-.652-.69-.43-.831l1.135-.628a29.064 29.064 0 012.968-1.297c2.429-.91 5.648-1.503 8.19-1.525 2.543-.033 5.776.491 8.223 1.35 1.226.423 2.264.884 2.995 1.233l1.149.603c.202.195-.159.892-.412.84zM212.104 222.53c.12.011.252.064.436.053l.588-.067.45-.052c.143-.022.263-.053.374-.086.399 3.434.686 6.482.879 8.94.191 2.051.28 3.7.366 4.831l.122 1.752c.109 1.32.995 1.325.936-.051l-.086-1.758c-.061-1.136-.118-2.79-.268-4.852-.245-4.126-.713-9.89-1.558-16.426a175.024 175.024 0 00-4.013-20.954c-.908-3.565-1.931-7.084-2.948-10.478l-1.526-4.981-.744-2.399-.052-.167a50.45 50.45 0 00-2.027-.409l2.654 8.472c1.037 3.374 2.086 6.86 3.026 10.384 1.89 7.044 3.342 14.242 4.274 20.723.335 2.289.621 4.479.867 6.543a2.89 2.89 0 00-.373-.014l-.452.042-.508.048c-.033.006-.132-.023-.26-.045l-.38-.073c-1.06-.23-2.625-.676-4.262-1.798a11.844 11.844 0 01-4.359-5.326 12.886 12.886 0 01-.606-1.939l-.402-2.169-.851-4.701-.907-4.999c-.329-1.701-.709-3.423-1.07-5.175l-2.246-10.68-2.154-10.161a64.92 64.92 0 00-1.823-.052l2.345 10.567 2.384 10.652c.386 1.746.793 3.468 1.146 5.156l.98 4.95.926 4.657.456 2.236c.179.747.427 1.455.708 2.128a12.967 12.967 0 004.883 5.748c1.809 1.186 3.514 1.635 4.664 1.859l.411.071zM132.286 285.652l2.72 13.895s11.039 29.798 12.598 34.988c-.687 10.236-22.357 16.766-32.872 15.469-7.138-11.886-3.23-40.382-3.23-40.382l-2.778-13.235 23.562-10.735z"
        fill="#172845"
      />
      <path
        d="M135.871 343.164c1.067 9.492-2.027 14.021-7.882 17.566-5.853 3.546-7.555 7.946-2.08 7.082 5.476-.864 12.393-3.167 15.274-6.335 2.882-3.167 8.07-22.747 6.421-26.943l-1.602-4.759"
        fill="#172845"
      />
      <path
        d="M139.165 341.319l-3.179 13.819a9.714 9.714 0 01-3.252 5.29c-2.471 2.058-6.134 5.093-8.027 6.583-3.02 2.377-5.033-.092-3.386-3.566 1.647-3.475 4.026-6.464 5.124-8.809 1.099-2.345 2.106-8.471 2.106-8.471"
        fill="#172845"
      />
      <path
        d="M112.832 345.76c1.35 6.805 4.095 16.68 5.468 19.422 1.373 2.743 4.301 1.006 4.667-1.097.366-2.103 1.155-6.4.423-16.823"
        fill="#172845"
      />
      <path
        d="M131.936 345.159c-.092 4.297-1.14 10.423-1.989 13.166-.848 2.743-3.811 9.198-7.363 9.628-3.551.43-1.538-6.881-.989-11.774.549-4.893.274-7.911.274-7.911"
        fill="#172845"
      />
      <path
        d="M135.006 299.547l-.166-.848c-2.732-.204-5.443 1.105-7.7 2.62-5.9 3.962-10.217 9.795-14.924 15.008a77.83 77.83 0 01-1.493 1.597c-.602 9.36-.67 24.29 4.009 32.081 10.516 1.298 32.185-5.233 32.872-15.469-1.558-5.191-12.598-34.989-12.598-34.989z"
        fill="url(#prefix__paint46_linear)"
      />
      <path
        d="M123.763 316.64c3.658 4.776 8.113 8.814 13.668 11.252 2.768 1.215 5.64 1.71 8.555 1.835-3.52-10.048-10.979-30.18-10.979-30.18l-.166-.849c-2.732-.203-5.443 1.106-7.699 2.62-3.223 2.165-5.969 4.892-8.569 7.768 1.652 2.57 3.331 5.127 5.19 7.554z"
        fill="url(#prefix__paint47_linear)"
      />
      <path
        d="M135.871 343.164c1.067 9.492-2.027 14.021-7.881 17.566-5.854 3.545-7.556 7.945-2.08 7.082 5.475-.864 12.392-3.167 15.274-6.335 2.881-3.167 8.069-22.747 6.42-26.943l-1.602-4.759"
        fill="url(#prefix__paint48_linear)"
      />
      <path
        d="M139.166 341.318l-3.18 13.819a9.716 9.716 0 01-3.252 5.291c-2.471 2.058-6.134 5.093-8.027 6.582-3.02 2.378-5.033-.091-3.386-3.565 1.648-3.475 4.026-6.464 5.125-8.809 1.098-2.346 2.105-8.471 2.105-8.471"
        fill="url(#prefix__paint49_linear)"
      />
      <path
        d="M112.833 345.76c1.35 6.804 4.095 16.679 5.468 19.422 1.373 2.742 4.301 1.005 4.667-1.098.366-2.103 1.155-6.4.423-16.823"
        fill="url(#prefix__paint50_linear)"
      />
      <path
        d="M131.937 345.158c-.092 4.297-1.14 10.423-1.989 13.166-.848 2.743-3.811 9.198-7.363 9.628-3.551.43-1.538-6.881-.989-11.774.549-4.893.274-7.911.274-7.911"
        fill="url(#prefix__paint51_linear)"
      />
      <path
        d="M128.964 170.865c25.947-29.242 40.87-49.3 42.134-73.28.932-17.686-7.865-24.705-16.573-24.705s-21.523 9.737-24.313 32.189c-2.203 17.736-12.616 78.608-1.248 65.796z"
        fill="url(#prefix__paint52_linear)"
      />
      <path
        d="M151.351 82.086c-2.079-3.064-6.104-4.086-9.49-2.585-6.427 2.85-12.799 9.805-20.862 24.126-9.953 17.678-44.6 86.176-46.811 118.583-2.212 32.408 9.952 83.229 17.692 105.325-4.237-13.522 37.965-41.246 43.125-27.989-11.058-53.03-11.747-91.474-2.003-123.626 9.743-32.152 16.747-50.565 19.696-64.56 2.302-10.923 3.004-22.86-1.347-29.274z"
        fill="url(#prefix__paint53_linear)"
      />
      <path
        d="M151.351 82.085c-2.079-3.063-9.677 13.175-17.74 27.497-9.952 17.677-43.286 82.204-45.497 114.612-2.211 32.408-3.973 81.246 3.767 103.342-4.237-13.523 37.965-41.247 43.125-27.989-11.058-53.031-11.747-91.475-2.003-123.626 9.743-32.152 16.747-50.566 19.695-64.56 2.302-10.924 3.004-22.86-1.347-29.276z"
        fill="url(#prefix__paint54_linear)"
      />
      <path
        d="M161.201 55.362c1.172 4.458 18.347 4.305 42.752-2.098 24.405-6.404 38.285-15.637 37.15-20.104-.825-3.252-16.989-2.442-41.393 3.962-24.404 6.403-39.681 13.782-38.509 18.24z"
        fill="url(#prefix__paint55_linear)"
      />
      <path
        d="M214.07 36.038c10.457 8.907 14.263 20.843 10.541 28.98 7.882 11.634 1.259 22.386-12.277 23.722-16.227 1.602-15.345-6.136-15.345-6.136-5.456-5.645-1.179-18.503 4.96-23.816-3.286-5.28.609-14.991.609-14.991l11.512-7.76z"
        fill="url(#prefix__paint56_linear)"
      />
      <path
        d="M168.331 76.652c5.69-.695 10.611 3.899 20.504 12.962 7.069 6.474 15.068 7.552 11.944-1.036 3.524-12.614 6.84-24.078 6.84-24.078s7.383-.547 9.99-1.759c2.606-1.212 6.125-24.017 2.232-39.767-3.893-15.75-46.392 18.798-46.392 18.798s10.572 18.98-5.118 34.88z"
        fill="url(#prefix__paint57_linear)"
      />
      <path
        d="M205.611 71.495c-9.24-1.728-12.407-9.667-14.869-10.182-6.106-1.278-4.605 5.6-10.05 2.564a68.663 68.663 0 01-4.189-2.564c-.87 4.955-3.199 10.3-8.171 15.339 5.689-.695 10.61 3.899 20.504 12.962 7.069 6.475 15.068 7.55 11.945-1.036a2942.83 2942.83 0 014.83-17.083z"
        fill="url(#prefix__paint58_linear)"
      />
      <path
        d="M219.842 22.974c-3.893-15.75-46.393 18.798-46.393 18.798s2.752 4.957 3.36 11.92c1.236.592 2.473 1.184 3.713 1.768 8.63 4.065 17.585 7.802 27.094 9.053 4.394 0 7.387-.561 9.993-1.773 2.606-1.211 6.125-24.017 2.233-39.767z"
        fill="url(#prefix__paint59_linear)"
      />
      <path
        d="M192.274 32.257c7.879 11.25 8.173 28.129 2.521 35.068 8.924 11.422-.437 31.166-13.108 26.226-10.557-4.116-5.569-16.423-17.104-16.9-3.859-6.834-.964-14.854 6.315-18.453-1.851-5.936 4.364-14.356 4.364-14.356l17.012-11.585z"
        fill="url(#prefix__paint60_linear)"
      />
      <path
        d="M186.278 76.652l1.493-7.212-3.733 1.343s4.913-4.94 6.827-12.997c1.845-7.76-1.864-17.756-3.112-22.449l-12.491 8.506s-6.215 8.42-4.364 14.356c-7.279 3.6-10.174 11.618-6.315 18.454 6.171.255 7.614 3.895 9.237 7.856 4.095 4.775 10.964-.644 12.458-7.857z"
        fill="url(#prefix__paint61_linear)"
      />
      <path
        d="M199.709 37.12c22.265-5.841 37.306-7.07 41.394-3.961-3.798-5.76-19.412-13.811-25.386-15.409-23.975 3.166-37.69 13.231-44.49 19.948-6.799 6.717-9.808 16.237-9.808 16.237h.004c2.348-4.73 16.268-11.037 38.286-16.815z"
        fill="#172845"
      />
      <path
        d="M221.574 19.98C217.047 6.303 210.454 1.31 202.577.105c-7.877-1.206-25.116 8.269-29.361 18.755-2.849 7.038-1.897 20.73-1.897 20.73s40.632-10.944 50.255-19.61z"
        fill="#172845"
      />
      <path
        d="M221.574 19.98C217.047 6.301 210.455 1.31 202.577.102c-7.877-1.205-25.117 8.27-29.361 18.755-2.201 5.438-2.133 14.842-1.988 18.84-6.799 6.717-9.808 16.238-9.808 16.238l.003-.001c2.348-4.73 16.267-11.037 38.287-16.815 22.264-5.841 37.306-7.07 41.393-3.961-2.862-4.34-12.429-9.979-19.529-13.18z"
        fill="url(#prefix__paint62_linear)"
      />
      <path
        d="M226.295 610.37s27.859-.43 45.794-.439c17.936.009 45.794.439 45.794.439.964.022.93.906 0 .936 0 0-27.858.431-45.794.439-17.935-.008-45.794-.439-45.794-.439-.952-.093-.937-.877 0-.936zM2.575 558.477l.143.32c.073.217.283.502.508.885.12.19.24.406.394.632l.54.719c.368.529.879 1.08 1.41 1.712 2.186 2.498 5.712 5.649 9.088 9.911 1.667 2.135 3.305 4.555 4.513 7.297 1.242 2.73 1.944 5.771 2.55 8.665l1.811 8.638c.622 2.787 1.281 5.473 2.245 7.775.479 1.147 1.074 2.281 1.883 3.205.81.917 1.848 1.577 3.081 1.745.305.063.619.057.947.078l1.093.006 2.205.011 4.459.029 17.326.151 18.802.216c1.12.022 1.082.906 0 .936l-18.802.216-17.326.15-4.46.028-2.204.013-1.093.005c-.395-.017-.81-.012-1.214-.088-.808-.121-1.619-.373-2.326-.791a7.63 7.63 0 01-1.835-1.508c-1.021-1.158-1.684-2.451-2.21-3.7-1.045-2.513-1.694-5.27-2.303-8.102-.6-2.835-1.13-5.759-1.714-8.675-.577-2.943-1.185-5.778-2.315-8.388-1.099-2.622-2.622-4.973-4.199-7.079-3.188-4.203-6.63-7.433-8.811-10.043-.534-.667-1.04-1.241-1.418-1.809l-.547-.769c-.157-.244-.284-.482-.407-.687-.232-.42-.441-.724-.523-.97l-.149-.358c-.377-1.118.4-1.287.858-.376zM184.051 469.766l.126-.341c.095-.211.25-.506.465-.876.439-.726 1.17-1.685 2.161-2.798 1.975-2.231 5.026-5.026 8.693-7.958 3.669-2.931 7.967-5.981 12.391-8.777 4.422-2.797 8.965-5.351 13.064-7.383 4.097-2.035 8.865-4.152 13.802-5.92 4.914-1.796 10.031-3.275 14.731-3.91 2.346-.328 4.594-.436 6.625-.273 2.027.161 3.849.663 5.208 1.476a7.238 7.238 0 011.631 1.374c.394.494.677.96.854 1.361.184.399.286.719.341.941.063.218.092.332.092.332.178 1.048-.723 1.056-.91.22l-.089-.284a4.473 4.473 0 00-.313-.792 5.366 5.366 0 00-.743-1.113 6.173 6.173 0 00-1.405-1.116c-1.185-.663-2.841-1.091-4.753-1.192-1.912-.104-4.067.05-6.336.421-4.551.724-9.521 2.267-14.353 4.122-4.842 1.822-9.526 3.964-13.571 5.978a170.379 170.379 0 00-12.992 7.178c-4.421 2.696-8.738 5.626-12.431 8.438-3.69 2.811-6.773 5.492-8.746 7.601-.988 1.051-1.71 1.947-2.126 2.592-.199.322-.343.578-.427.747l-.104.261c-.118.193-.173.304-.282.397a.54.54 0 01-.329.147c-.108-.001-.206-.063-.268-.211a.89.89 0 01-.006-.642zM274.821 571.938c-1.342.294-2.997.736-4.256 1.192-1.257.462-2.806 1.192-4.023 1.831-1.218.638-2.108 1.174-2.108 1.174-.114.085.255.889.393.849l6.361-2.151a7791.22 7791.22 0 015.255-2.064 69.266 69.266 0 01-.302-1.105c-.372.073-.824.165-1.32.274zM269.643 582.889c-1.135.777-1.956 1.413-1.956 1.413-.102.098.359.853.491.797l6.063-2.886 4.73-2.537c-.169-.36-.333-.725-.491-1.094-.294.096-.621.205-.974.328-1.298.45-2.89 1.084-4.085 1.685-1.193.609-2.646 1.516-3.778 2.294zM262.838 567.446l2.264-.472 4.134-.773 4.113-.879 1.406-.27c-.06-.373-.118-.744-.173-1.114-.386 0-.862.006-1.394.025-1.346.046-3.02.205-4.309.46-1.288.261-2.893.759-4.153 1.235-1.262.472-2.185.9-2.185.9-.119.071.159.91.297.888zM126.876 364.099s.602-1.409 1.268-3.308c.675-1.896 1.365-4.293 1.868-6.174.514-1.878 1.127-4.295 1.5-6.274.382-1.976.573-3.496.573-3.496.038-.748.922-.69.935.062 0 0 .024 1.56-.151 3.62-.164 2.06-.579 4.611-1.106 6.56-.528 1.95-1.456 4.362-2.353 6.224-.889 1.868-1.695 3.203-1.695 3.203-.468.735-1.18.404-.839-.417zM121.656 364.426l.574-7.277.854-7.25c.057-.61.943-.585.936.015 0 0 .095 1.124.137 2.616.045 1.491.019 3.349-.12 4.796-.146 1.446-.482 3.274-.816 4.728-.331 1.455-.644 2.539-.644 2.539-.243.606-1.044.57-.921-.167zM129.751 365.309s.401-.216 1.015-.651a14.66 14.66 0 002.235-1.98c.813-.873 1.598-1.965 2.274-3.109a25.753 25.753 0 001.647-3.442c.879-2.167 1.665-5.1 2.145-7.523.49-2.42 1.278-5.96 1.278-5.96.052-.587.93-.43.929.118 0 0-.573 3.558-.855 6.058-.271 2.495-.869 5.628-1.809 7.97a20.245 20.245 0 01-1.92 3.665c-.809 1.2-1.758 2.321-2.725 3.193a14.71 14.71 0 01-2.628 1.915c-.711.399-1.167.582-1.167.582-.656.221-1.011-.479-.419-.836z"
        fill="#172845"
      />
      <path
        d="M336.127 280.346c5.841 3.97 7.357 11.924 3.387 17.764-3.969 5.841-11.923 7.358-17.763 3.388-5.841-3.97-7.358-11.923-3.388-17.764 3.97-5.841 11.923-7.357 17.764-3.388z"
        fill="url(#prefix__paint63_radial)"
      />
      <path d="M330.985 287.911a3.641 3.641 0 11-4.094 6.023 3.641 3.641 0 014.094-6.023z" fill="#E7AD80" fillOpacity={0.5} />
      <path d="M330.985 287.911a3.641 3.641 0 11-4.094 6.023 3.641 3.641 0 014.094-6.023z" fill="url(#prefix__paint64_radial)" />
      <path
        d="M27.459 330.83c4.981 3.386 6.275 10.169 2.889 15.151-3.386 4.982-10.17 6.275-15.151 2.889-4.982-3.386-6.276-10.169-2.89-15.151 3.386-4.982 10.17-6.275 15.152-2.889z"
        fill="url(#prefix__paint65_radial)"
      />
      <path d="M23.08 337.273a3.116 3.116 0 11-3.504 5.155 3.116 3.116 0 013.503-5.155z" fill="#E7AD80" fillOpacity={0.5} />
      <path d="M23.08 337.273a3.116 3.116 0 11-3.504 5.155 3.116 3.116 0 013.503-5.155z" fill="url(#prefix__paint66_radial)" />
      <path
        d="M23.33 99.007c7.32 4.975 9.222 14.943 4.246 22.263-4.975 7.32-14.943 9.221-22.263 4.245-7.32-4.975-9.22-14.943-4.245-22.263 4.975-7.32 14.943-9.22 22.263-4.245z"
        fill="url(#prefix__paint67_radial)"
      />
      <path d="M16.886 108.487a4.563 4.563 0 11-5.13 7.548 4.563 4.563 0 015.13-7.548z" fill="#E7AD80" fillOpacity={0.5} />
      <path d="M16.886 108.487a4.563 4.563 0 11-5.13 7.548 4.563 4.563 0 015.13-7.548z" fill="url(#prefix__paint68_radial)" />
    </g>
    <defs>
      <linearGradient id="prefix__paint1_linear" x1={344.369} y1={186.633} x2={357.578} y2={219.169} gradientUnits="userSpaceOnUse">
        <stop offset={0.009} stopColor="#F0E6DA" />
        <stop offset={0.205} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint2_linear" x1={291.788} y1={156.594} x2={374.183} y2={120.293} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint3_linear" x1={400.966} y1={172.9} x2={336.218} y2={122.278} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#F0E6DA" />
      </linearGradient>
      <linearGradient id="prefix__paint4_linear" x1={370.808} y1={211.473} x2={306.06} y2={160.85} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#F0E6DA" />
      </linearGradient>
      <linearGradient id="prefix__paint5_linear" x1={381.092} y1={200.593} x2={248.58} y2={187.005} gradientUnits="userSpaceOnUse">
        <stop offset={0.009} stopColor="#F0E6DA" />
        <stop offset={0.205} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint6_linear" x1={372.255} y1={199.664} x2={287.863} y2={191.024} gradientUnits="userSpaceOnUse">
        <stop offset={0.009} stopColor="#F0E6DA" />
        <stop offset={0.205} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint7_linear" x1={348.799} y1={196.68} x2={313.002} y2={194.077} gradientUnits="userSpaceOnUse">
        <stop offset={0.009} stopColor="#F0E6DA" />
        <stop offset={0.205} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint8_linear" x1={324.432} y1={176.35} x2={321.873} y2={192.052} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={1} stopColor="#AF6E41" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint9_linear" x1={344.3} y1={185.371} x2={342.979} y2={203.387} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={1} stopColor="#AF6E41" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint10_linear" x1={345.923} y1={179.854} x2={343.363} y2={195.556} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={1} stopColor="#AF6E41" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint11_linear" x1={327.422} y1={184.134} x2={326.101} y2={202.149} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={1} stopColor="#AF6E41" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint12_linear" x1={329.293} y1={177.143} x2={326.734} y2={192.845} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={1} stopColor="#AF6E41" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint13_linear" x1={339.117} y1={187.599} x2={337.052} y2={198.673} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={1} stopColor="#AF6E41" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint14_linear" x1={340.361} y1={178.947} x2={337.801} y2={194.649} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={1} stopColor="#AF6E41" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint15_linear" x1={311.914} y1={188.465} x2={370.13} y2={196.523} gradientUnits="userSpaceOnUse">
        <stop offset={0.009} stopColor="#F0E6DA" />
        <stop offset={0.205} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint16_linear" x1={383.057} y1={125.715} x2={337.1} y2={121.39} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#F0E6DA" />
      </linearGradient>
      <linearGradient id="prefix__paint17_linear" x1={290.13} y1={152.83} x2={372.525} y2={116.529} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint18_linear" x1={297.696} y1={170.003} x2={380.091} y2={133.702} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint19_linear" x1={295.3} y1={164.568} x2={377.696} y2={128.267} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint20_linear" x1={292.868} y1={159.047} x2={375.263} y2={122.745} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint21_linear" x1={269.876} y1={102.637} x2={206.824} y2={182.604} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint22_linear" x1={350.484} y1={106.153} x2={194.379} y2={133.157} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint23_linear" x1={182.09} y1={106.309} x2={220.633} y2={106.309} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint24_linear" x1={289.069} y1={150.423} x2={371.464} y2={114.122} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint25_linear" x1={328.987} y1={196.241} x2={261.423} y2={131.367} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={0.607} stopColor="#E7AD80" />
        <stop offset={0.926} stopColor="#F0E6DA" />
      </linearGradient>
      <linearGradient id="prefix__paint26_linear" x1={347.26} y1={165.948} x2={278.006} y2={206.807} gradientUnits="userSpaceOnUse">
        <stop offset={0.009} stopColor="#F0E6DA" />
        <stop offset={0.205} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint27_linear" x1={339.839} y1={186.729} x2={272.275} y2={121.856} gradientUnits="userSpaceOnUse">
        <stop stopColor="#172845" />
        <stop offset={0.607} stopColor="#E7AD80" />
        <stop offset={0.926} stopColor="#F0E6DA" />
      </linearGradient>
      <linearGradient id="prefix__paint28_linear" x1={67.023} y1={-4.132} x2={127.354} y2={121.177} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint29_linear" x1={15.982} y1={77.966} x2={85.875} y2={150.645} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint30_linear" x1={266.529} y1={575.608} x2={221.218} y2={475.549} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint31_linear" x1={274.113} y1={529.935} x2={195.044} y2={455.334} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint32_linear" x1={304.713} y1={482.577} x2={132.705} y2={624.42} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint33_linear" x1={54.096} y1={388.104} x2={107.867} y2={316.348} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint34_linear" x1={251.523} y1={6.39} x2={152.868} y2={177.609} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint35_linear" x1={203.425} y1={121.731} x2={103.749} y2={153.085} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint36_linear" x1={237.435} y1={520.867} x2={29.055} y2={476.15} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint37_linear" x1={476.756} y1={211.548} x2={-15.773} y2={422.712} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint38_linear" x1={284.905} y1={229.996} x2={100.162} y2={509.016} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint39_linear" x1={343.227} y1={481.478} x2={208.799} y2={571.056} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint40_linear" x1={332.951} y1={466.057} x2={198.524} y2={555.636} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint41_linear" x1={351.946} y1={534.129} x2={218.913} y2={632.142} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint42_linear" x1={351.946} y1={534.129} x2={218.913} y2={632.142} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint43_linear" x1={361.603} y1={547.237} x2={228.57} y2={645.25} gradientUnits="userSpaceOnUse">
        <stop offset={0.254} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint44_linear" x1={173.983} y1={521.246} x2={13.759} y2={527.884} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint45_linear" x1={173.513} y1={562.746} x2={-8.428} y2={576.926} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint46_linear" x1={181.046} y1={282.173} x2={90.267} y2={359.996} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint47_linear" x1={178.779} y1={292.45} x2={42.779} y2={366.729} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint48_linear" x1={196.596} y1={300.311} x2={105.817} y2={378.134} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint49_linear" x1={194.886} y1={298.316} x2={104.107} y2={376.14} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint50_linear" x1={190.524} y1={293.228} x2={99.746} y2={371.052} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint51_linear" x1={193.92} y1={297.189} x2={103.142} y2={375.012} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint52_linear" x1={191.815} y1={110.552} x2={159.091} y2={118.235} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.999} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint53_linear" x1={267.341} y1={120.464} x2={31.871} y2={250.595} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint54_linear" x1={169.644} y1={171.576} x2={47.576} y2={258.013} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint55_linear" x1={214.917} y1={87.678} x2={199.709} y2={39.627} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint56_linear" x1={223.457} y1={74.565} x2={175.661} y2={37.148} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint57_linear" x1={205.447} y1={84.933} x2={195.047} y2={52.698} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint58_linear" x1={210.462} y1={106.079} x2={178.698} y2={62.727} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <linearGradient id="prefix__paint59_linear" x1={215.415} y1={57.709} x2={180.84} y2={17.393} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint60_linear" x1={198.116} y1={80.9} x2={126.659} y2={-15.255} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint61_linear" x1={214.088} y1={127.037} x2={137.896} y2={-15.948} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#172845" />
      </linearGradient>
      <linearGradient id="prefix__paint62_linear" x1={263.94} y1={33.566} x2={173.863} y2={26.346} gradientUnits="userSpaceOnUse">
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </linearGradient>
      <radialGradient
        id="prefix__paint0_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="matrix(108.683 0 0 108.588 346.602 126.715)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={0.192} stopColor="#E7AD80" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint63_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-157.492 193.24 112.886) scale(10.3854)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint64_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-157.491 193.411 112.733) scale(3.63065)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint65_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-157.491 44.337 167.912) scale(8.85122)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint66_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-157.491 44.481 167.784) scale(3.09433)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint67_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-157.491 18.114 54.86) scale(13.0159)"
      >
        <stop offset={0.003} stopColor="#E7AD80" />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <radialGradient
        id="prefix__paint68_radial"
        cx={0}
        cy={0}
        r={1}
        gradientUnits="userSpaceOnUse"
        gradientTransform="rotate(-157.491 18.326 54.672) scale(4.55024)"
      >
        <stop stopColor="#F0E6DA" stopOpacity={0.965} />
        <stop offset={1} stopColor="#E7AD80" stopOpacity={0} />
      </radialGradient>
      <clipPath id="prefix__clip0">
        <path fill="#fff" d="M0 0h455.284v617H0z" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
